import { AutoRefreshTokenService, KeycloakService, provideKeycloak, UserActivityService, withAutoRefreshToken } from 'keycloak-angular';

import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const initializeKeycloak = (keycloak: KeycloakService) => async () => {
  try {
    await keycloak.init({
      config: {
        url: environment.keycloak.authority,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      loadUserProfileAtStartUp: true,
      initOptions: {
        checkLoginIframe: false,
        onLoad: 'check-sso',
        redirectUri: environment.keycloak.redirectUri,
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
        scope: 'openid',
      },
      enableBearerInterceptor: true
    });
  } catch (error) {
    console.error('Keycloak initialization failed:', error);
    throw error;
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloak({
      config: {
        url: environment.keycloak.authority,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        checkLoginIframe: false,
        onLoad: 'check-sso',
        redirectUri: environment.keycloak.redirectUri,
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
        scope: 'openid',
      },
      features: [
        withAutoRefreshToken({
          onInactivityTimeout: 'logout',
          sessionTimeout: 60000
        })
      ],
      providers: [AutoRefreshTokenService, UserActivityService]
    }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
  ],
};
